import { Menu, MenuProps, PopoverOrigin, Tooltip } from '@mui/material';
import { WrapWith } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { Actions, PageAction } from './components/Actions';

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};
const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

interface ActionsMenuProps extends MenuProps {
  actions: PageAction[];
}

export const ActionsMenu = ({ actions, ...props }: ActionsMenuProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeDetail.action' });

  return (
    <Menu {...props} anchorOrigin={ANCHOR_ORIGIN} transformOrigin={TRANSFORM_ORIGIN}>
      <WrapWith component={Tooltip} title={t(`remove.noPermission`)} placement="left">
        <div>
          <Actions actions={actions} />
        </div>
      </WrapWith>
    </Menu>
  );
};
